import type { OptimizationBlockState, ResumeOptimizationRun } from './types'

const TERMINAL_BLOCK_STATUSES = new Set<OptimizationBlockState['status']>([
  'done',
  'skipped',
  'failed',
])

export function allBlocksTerminal(blocks: OptimizationBlockState[]): boolean {
  return blocks.length > 0 && blocks.every((b) => TERMINAL_BLOCK_STATUSES.has(b.status))
}

export function hasBlocksInFlight(blocks: OptimizationBlockState[]): boolean {
  return blocks.some((b) => b.status === 'pending' || b.status === 'running')
}

export function runBlocksFingerprint(run: ResumeOptimizationRun): string {
  const blocks = run.blocks ?? []
  const blockPart = blocks
    .map((b) => `${b.block_id}:${b.status}:${b.duration_ms ?? ''}`)
    .join(';')
  return `${run.status}|${run.updated_at}|${blockPart}`
}

export function countFailedBlocks(blocks: OptimizationBlockState[]): number {
  return blocks.filter((b) => b.status === 'failed').length
}
